module.exports = __webpack_public_path__ + "img/3_149.6e1916b4.png";